export default "__VITE_ASSET__DzTUTeMH__"